import React, { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { QuillInputField } from 'components/form';
import { FinanceProgramForm } from '../../../../schema';
import { FormSection } from '../../FormSection';

interface Props {
  isReadOnly: boolean;
}

export const InsuranceCoverageRequirements = ({ isReadOnly }: Props) => {
  const { control, setValue, getValues, resetField } = useFormContext<FinanceProgramForm>();

  // To reset the innerValue of QuillInputField (force it to re-mount with the default value)
  const [resetKey, setResetKey] = useState(0);

  const handleReset = useCallback(() => {
    resetField('program.first.insuranceCoverage');
    setResetKey(prev => prev + 1);
  }, [resetField]);

  return (
    <FormSection title="Insurance Coverage Requirements" onReset={handleReset} isReadOnly={isReadOnly}>
      <QuillInputField
        key={`coverageRequirements-${resetKey}`}
        control={control}
        setValue={setValue}
        getValues={getValues}
        readOnly={isReadOnly}
        label="Coverage Requirements:"
        name="program.first.insuranceCoverage.coverageRequirements"
      />

      <QuillInputField
        key={`certificateRequirements-${resetKey}`}
        control={control}
        setValue={setValue}
        getValues={getValues}
        readOnly={isReadOnly}
        label="Certificate Requirements:"
        name="program.first.insuranceCoverage.certificateRequirements"
      />

      <QuillInputField
        key={`otherInstructions-${resetKey}`}
        control={control}
        setValue={setValue}
        readOnly={isReadOnly}
        getValues={getValues}
        label="Other Instructions:"
        name="program.first.insuranceCoverage.otherInstructions"
      />
    </FormSection>
  );
};
